document.addEventListener('DOMContentLoaded', () => {

    const container = document.querySelector('.wp-block-wm-cardioline-product-floating-text-with-image');
    const textElement = container?.querySelector('.wp-block-wm-cardioline-product-floating-text-with-image__text');

    if (!container || !textElement) return;

/*     const isMobileScreen = () => window.innerWidth < 768;
    if (isMobileScreen()) return;
    window.addEventListener('resize', () => {
        if (isMobileScreen()) return;
    }); */

    window.addEventListener('scroll', () => {

        if ( window.innerWidth < 768 ) {
            return;
        }
        
        const containerRect = container.getBoundingClientRect();
        const containerTop = containerRect.top;
        const containerBottom = containerRect.bottom;
        const textHeight = textElement.offsetHeight;

        if (containerTop <= 0 && containerBottom >= textHeight) {
            // Element is in viewport, fix it
            textElement.style.position = 'fixed';
            textElement.style.top = '0';
        } else if (containerBottom < textHeight) {
            // Reached bottom of container, stick to bottom
            textElement.style.position = 'absolute';
            textElement.style.top = (container.offsetHeight - textHeight) + 'px';
        } else {
            // Above container, release
            textElement.style.position = 'relative';
            textElement.style.top = '0';
        }
    });
});